import { createSlice } from "@reduxjs/toolkit";

import { addWebSocketCases } from "../helpers/storeAction";
import {
  addNewVesselData,
  deleteVessel,
  fetchVesselListData,
  updateVessel,
} from "../thunks/vesselThunk";

interface VesselListState {
  vesselList: any[];
  loading: boolean;
  error: string | null;
  isDataFetched?: boolean;
}

const initialState: VesselListState = {
  vesselList: [],
  loading: false,
  error: null,
  isDataFetched: false,
};

export const vesselListSlice = createSlice({
  name: "vesselList",
  initialState,
  reducers: {
    resetDataFetched: (state) => {
      state.isDataFetched = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchVesselListData.pending, (state) => {
        state.loading = true;
        state.isDataFetched = true;
      })
      .addCase(fetchVesselListData.fulfilled, (state, action) => {
        state.vesselList = action.payload || [];
        state.loading = false;
      })
      .addCase(fetchVesselListData.rejected, (state, action) => {
        state.error = action.payload as string;
        state.isDataFetched = false;
        state.loading = false;
      });
    builder
      .addCase(deleteVessel.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteVessel.fulfilled, (state, action) => {
        state.vesselList = state.vesselList.filter(
          (vessel) => vessel.vessel_id !== action.payload
        );
        state.loading = false;
      })
      .addCase(deleteVessel.rejected, (state) => {
        state.loading = false;
        state.error = "Unknown error… Please try again";
      });

      builder
        .addCase(updateVessel.pending, (state) => {
          state.loading = true;
          state.error = null;
        })
        .addCase(updateVessel.fulfilled, (state, action) => {
          state.vesselList = state.vesselList.map((vessel) => {
            if (vessel.vessel_id === action.payload?.vessel_id) {
              return { ...vessel, ...action.payload };
            }
            return vessel;
          });
          state.loading = false;
        })
        .addCase(updateVessel.rejected, (state) => {
          state.loading = false;
          state.error = "Unknown error… Please try again";
        });
  
      builder
        .addCase(addNewVesselData.pending, (state) => {
          state.loading = true;
          state.error = null;
        })
        .addCase(addNewVesselData.fulfilled, (state, action) => {
          state.vesselList = [action.payload, ...state.vesselList];
          state.loading = false;
        })
        .addCase(addNewVesselData.rejected, (state) => {
          state.loading = false;
          state.error = "Unknown error… Please try again";
        });
        addWebSocketCases(builder, "vesselList", "vesselList");
  },
});

export const { resetDataFetched } = vesselListSlice.actions;
export default vesselListSlice.reducer;
